import { render, staticRenderFns } from "./IconInstagramLight.vue?vue&type=template&id=147e1e4b&"
import script from "./IconInstagramLight.vue?vue&type=script&lang=js&"
export * from "./IconInstagramLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports